/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 添加/取消项目设置的本次观演人
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  saveProductCommonlyDto: order.SaveProductCommonlyDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "patch",
    url: `/order/product-commonly`,
    data: saveProductCommonlyDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
